module.exports = __webpack_public_path__ + "img/pageArrow.50113a80.svg";